import script from "./item.vue?vue&type=script&setup=true&lang=ts"
export * from "./item.vue?vue&type=script&setup=true&lang=ts"

import "./item.vue?vue&type=style&index=0&id=7c9f48d4&scoped=true&lang=less"
import "./item.vue?vue&type=style&index=1&id=7c9f48d4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c9f48d4"]])

export default __exports__